import SvgIcon from '@components/SvgIcon'
import useHeaderSearchBar from '@hooks/useHeaderSearchBar'
import { NormalizedWeatherData, useWeather } from '@hooks/useWeather'
import { desktopCSS, tabletCSS } from '@measures/responsive'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import Blink from '@components/Blink'
import config from '@config'

interface WeatherProps {
  className?: string
}
interface StyledContainerProps {
  isWeatherVisible: boolean
}

const {
  publication: { publication },
  weather: { meteoNewsUrl },
} = config

const Container = styled(
  publication === 'blick' ? Blink : 'div'
)<StyledContainerProps>`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_100 },
      },
    },
    isWeatherVisible,
  }) => {
    return css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      text-decoration: none;

      font-family: ${sourceSansPro};
      color: ${grey_100};
      width: 64px;
      overflow: hidden;

      transition: width 0.2s ease-in-out;

      ${isWeatherVisible &&
      css`
        ${desktopCSS(
          css`
            width: 0;
          `
        )}

        ${tabletCSS(
          css`
            width: 0;
          `
        )}
      `}
    `
  }}
`

const Temperature = styled.div`
  height: 40px;
  padding-bottom: 5px;
  padding-left: 4px;
`

const TemperatureValue = styled.span`
  font-size: 14px;
  line-height: 45px;
  color: ${({ theme }) => theme.colors.grey.grey_80};
`

const Weather: FunctionComponent<WeatherProps> = ({ className }) => {
  const { isSearchBarCollapsed } = useHeaderSearchBar()
  const weatherData = useWeather()

  const { temperature, iconName, location } =
    weatherData as NormalizedWeatherData

  return (
    <Container
      isWeatherVisible={!isSearchBarCollapsed}
      className={className}
      href={meteoNewsUrl}
      target="_blank">
      {temperature && location && iconName && (
        <>
          <SvgIcon iconName={iconName} size={40} />
          <Temperature>
            <TemperatureValue>{temperature}˚</TemperatureValue>
          </Temperature>
        </>
      )}
    </Container>
  )
}

export default Weather
